import _implicitStylesheets from "./securityReviewSubmission.css";
import _implicitScopedStylesheets from "./securityReviewSubmission.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import _appxSecurityReviewSubmissionFailed from "appx/securityReviewSubmissionFailed";
import _i18nLink from "i18n/link";
import _appxAccordionRow from "appx/accordionRow";
import _appxAccordion from "appx/accordion";
import _appxSecurityReviewRaiseAChallenge from "appx/securityReviewRaiseAChallenge";
import _appxSecurityReviewFalsePositives from "appx/securityReviewFalsePositives";
import _lightningProgressStep from "lightning/progressStep";
import _lightningProgressIndicator from "lightning/progressIndicator";
import _c360Button from "c360/button";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div${"c0"}${2}><span class="status slds-m-right--xx-small${0}"${2}>${"t2"}</span><span class="status-date${0}"${2}>${"t4"}</span></div>`;
const $fragment2 = parseFragment`<div class="review-status-title slds-m-bottom--x-small${0}"${2}>${"t1"}</div>`;
const $fragment3 = parseFragment`<div class="review-status-subtitle${0}"${2}>${"t1"}</div>`;
const $fragment4 = parseFragment`<div class="submitted-titles slds-size--1-of-1${0}" data-test-id="challenge-raised"${2}><div class="slds-m-bottom--medium challenge-title${0}"${2}>${"t2"}</div></div>`;
const $fragment5 = parseFragment`<div${3}><div class="challenge-title-datetime slds-m-bottom--medium${0}"${2}>${"t2"}</div></div>`;
const $fragment6 = parseFragment`<div class="slds-grid challenge-text-container slds-m-bottom_large${0}"${2}><div class="vertical-divider${0}"${2}></div><div class="challenge-text slds-m-left_medium${0}"${2}>${"t3"}</div></div>`;
const $fragment7 = parseFragment`<span class="feedback-status-title${0}"${2}>${"t1"}</span>`;
const $fragment8 = parseFragment`<div class="feedback-action-title${0}"${2}>${"t1"}</div>`;
const $fragment9 = parseFragment`<div${3}><hr class="feedback-line${0}"${2}><span class="feedback-title${0}"${2}>${"t3"}</span><div${3}>${"t5"}</div></div>`;
const $fragment10 = parseFragment`<div class="feedback-action-title${0}"${2}>${"t1"}</div>`;
const $fragment11 = parseFragment`<div${3}><hr class="feedback-line${0}"${2}><span class="feedback-title${0}"${2}>${"t3"}</span><div${3}>${"t5"}</div></div>`;
const $fragment12 = parseFragment`<div class="feedback-action-title${0}"${2}>${"t1"}</div>`;
const $fragment13 = parseFragment`<div${3}><hr class="feedback-line${0}"${2}><span class="feedback-title${0}"${2}>${"t3"}</span><div${3}>${"t5"}</div></div>`;
const $fragment14 = parseFragment`<span class="feedback-status-title${0}"${2}>${"t1"}</span>`;
const $fragment15 = parseFragment`<div class="what-will-happen-now slds-m-vertical--large${0}"${2}><div class="submitted-titles slds-p-right_small slds-size--1-of-2${0}"${2}><div class="title${0}"${2}>${"t3"}</div><div data-test-id="what-will-happen-by-status" class="subtitle-next-steps slds-m-bottom_small${0}"${2}>${"t5"}</div><div class="body-2-text${0}" data-test-id="post-submission-text"${2}>${"t7"}</div></div><div class="slds-size--1-of-2${0}"${2}><img${"a9:alt"}${"a9:src"} variant="basic" width="600px" height="200px"${3}></div></div>`;
const $fragment16 = parseFragment`<div class="slds-col slds-size_1-of-1 slds-m-bottom--medium title${0}"${2}>${"t1"}</div>`;
const $fragment17 = parseFragment`<div class="slds-col slds-size_11-of-12${0}"${2}><span class="body-2-text${0}"${2}>${"t2"}</span></div>`;
const $fragment18 = parseFragment`<div class="slds-col slds-size_1-of-12${0}"${2}></div>`;
const $fragment19 = parseFragment`<div class="horizontal-divider slds-size--1-of-1 slds-m-vertical--small${0}"${2}></div>`;
const $fragment20 = parseFragment`<div class="slds-col slds-size_11-of-12${0}"${2}><span class="body-2-text${0}"${2}>${"t2"}</span></div>`;
const $fragment21 = parseFragment`<div class="slds-col slds-size_1-of-12${0}"${2}></div>`;
const $fragment22 = parseFragment`<div class="slds-col slds-size_1-of-1 slds-m-bottom--medium title${0}"${2}>${"t1"}</div>`;
const $fragment23 = parseFragment`<div class="slds-col slds-size_11-of-12${0}"${2}><span data-test-id="book-office-hour" class="body-2-text${0}"${2}>${"t2"}</span></div>`;
const $fragment24 = parseFragment`<div class="slds-col slds-size_1-of-12${0}"${2}></div>`;
const $fragment25 = parseFragment`<div class="slds-col slds-size_1-of-1 slds-m-bottom--medium title${0}"${2}>${"t1"}</div>`;
const $fragment26 = parseFragment`<div class="slds-col slds-size_11-of-12${0}"${2}><span data-test-id="book-office-hour" class="body-2-text${0}"${2}>${"t2"}</span></div>`;
const $fragment27 = parseFragment`<div class="slds-col slds-size_1-of-12${0}"${2}></div>`;
const $fragment28 = parseFragment`<div class="horizontal-divider slds-size--1-of-1 slds-m-vertical--small${0}"${2}></div>`;
const $fragment29 = parseFragment`<div class="slds-col slds-size_11-of-12 body-2-text${0}"${2}>${"t1"}</div>`;
const $fragment30 = parseFragment`<div class="slds-col slds-size_1-of-12${0}"${2}></div>`;
const $fragment31 = parseFragment`<div class="horizontal-divider slds-size--1-of-1 slds-m-vertical--small${0}"${2}></div>`;
const $fragment32 = parseFragment`<div class="slds-col slds-size_11-of-12 body-2-text${0}"${2}>${"t1"}</div>`;
const $fragment33 = parseFragment`<div class="slds-col slds-size_1-of-12${0}"${2}></div>`;
const $fragment34 = parseFragment`<div class="horizontal-divider slds-size--1-of-1 slds-m-vertical--small${0}"${2}></div>`;
const $fragment35 = parseFragment`<div class="slds-col slds-size_11-of-12 body-2-text${0}"${2}>${"t1"}</div>`;
const $fragment36 = parseFragment`<div class="slds-col slds-size_1-of-12${0}"${2}></div>`;
const stc0 = {
  classMap: {
    "submitted-component": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "slds-m-bottom_xx-large": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "slds-p-bottom--medium": true,
    "slds-grid": true,
    "slds-grid_vertical-align-center": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_vertical-align-top": true
  },
  key: 12
};
const stc4 = {
  classMap: {
    "challenge-icon": true,
    "slds-m-right_medium": true
  },
  key: 13
};
const stc5 = {
  props: {
    "size": "x-small",
    "iconName": "utility:alert",
    "iconClass": "error"
  },
  key: 14
};
const stc6 = {
  key: 19
};
const stc7 = {
  classMap: {
    "clean-accordion": true
  },
  props: {
    "isCard": "true"
  },
  key: 22
};
const stc8 = {
  props: {
    "isOpen": true
  },
  key: 23
};
const stc9 = {
  classMap: {
    "slds-m-right_x-small": true
  },
  slotAssignment: "summaryIcon",
  props: {
    "iconName": "utility:error",
    "size": "x-small",
    "iconClass": "error"
  },
  key: 24
};
const stc10 = {
  slotAssignment: "summary",
  classMap: {
    "feedback-status-sub-title": true
  },
  key: 25
};
const stc11 = {
  "resolve-action-item": true
};
const stc12 = {
  slotAssignment: "detail",
  classMap: {
    "detail-padding": true
  },
  key: 27
};
const stc13 = {
  "feedback-action-sub-title": true
};
const stc14 = {
  props: {
    "isOpen": true
  },
  key: 33
};
const stc15 = {
  classMap: {
    "slds-m-right_x-small": true
  },
  slotAssignment: "summaryIcon",
  props: {
    "iconName": "utility:error",
    "size": "x-small",
    "iconClass": "error"
  },
  key: 34
};
const stc16 = {
  slotAssignment: "summary",
  classMap: {
    "feedback-status-sub-title": true
  },
  key: 35
};
const stc17 = {
  slotAssignment: "detail",
  classMap: {
    "detail-padding": true
  },
  key: 37
};
const stc18 = {
  props: {
    "isOpen": true
  },
  key: 43
};
const stc19 = {
  classMap: {
    "slds-m-right_x-small": true
  },
  slotAssignment: "summaryIcon",
  props: {
    "iconName": "utility:error",
    "size": "x-small",
    "iconClass": "error"
  },
  key: 44
};
const stc20 = {
  slotAssignment: "summary",
  classMap: {
    "feedback-status-sub-title": true
  },
  key: 45
};
const stc21 = {
  slotAssignment: "detail",
  classMap: {
    "detail-padding": true
  },
  key: 46
};
const stc22 = {
  props: {
    "isOpen": true
  },
  key: 52
};
const stc23 = {
  classMap: {
    "slds-m-right_x-small": true
  },
  slotAssignment: "summaryIcon",
  props: {
    "iconName": "utility:error",
    "size": "x-small",
    "iconClass": "error"
  },
  key: 53
};
const stc24 = {
  slotAssignment: "summary",
  classMap: {
    "feedback-status-sub-title": true
  },
  key: 54
};
const stc25 = {
  slotAssignment: "detail",
  classMap: {
    "detail-padding": true,
    "no-top-margin": true
  },
  key: 55
};
const stc26 = {
  classMap: {
    "clean-accordion": true
  },
  key: 58
};
const stc27 = {
  props: {
    "isOpen": true
  },
  key: 59
};
const stc28 = {
  classMap: {
    "slds-m-right_x-small": true
  },
  slotAssignment: "summaryIcon",
  props: {
    "iconName": "utility:error",
    "size": "x-small",
    "iconClass": "error"
  },
  key: 60
};
const stc29 = {
  slotAssignment: "summary",
  classMap: {
    "feedback-status-sub-title": true
  },
  key: 61
};
const stc30 = {
  slotAssignment: "detail",
  classMap: {
    "detail-padding": true,
    "no-top-margin": true
  },
  attrs: {
    "data-test-id": "partner-waiting-reason"
  },
  key: 62
};
const stc31 = {
  classMap: {
    "slds-grid": true,
    "slds-m-vertical--large": true
  },
  key: 65
};
const stc32 = {
  classMap: {
    "oppties": true,
    "slds-grid": true,
    "slds-wrap": true,
    "slds-gutters": true
  },
  key: 67
};
const stc33 = {
  classMap: {
    "slds-grid": true,
    "slds-wrap": true
  },
  key: 70
};
const stc34 = {
  classMap: {
    "slds-size_1-of-12": true,
    "slds-col": true
  },
  key: 71
};
const stc35 = {
  props: {
    "size": "x-small",
    "iconName": "utility:info",
    "iconClass": "normal"
  },
  key: 72
};
const stc36 = {
  classMap: {
    "slds-col": true,
    "slds-size_11-of-12": true,
    "slds-list_horizontal": true
  },
  key: 77
};
const stc37 = {
  "body-2-text": true
};
const stc38 = {
  props: {
    "iconName": "utility:new_window",
    "size": "x-small",
    "iconClass": "normal"
  },
  key: 79
};
const stc39 = {
  classMap: {
    "slds-grid": true,
    "slds-wrap": true
  },
  key: 82
};
const stc40 = {
  classMap: {
    "slds-size_1-of-12": true,
    "slds-col": true
  },
  key: 83
};
const stc41 = {
  props: {
    "size": "x-small",
    "iconName": "utility:info",
    "iconClass": "normal"
  },
  key: 84
};
const stc42 = {
  classMap: {
    "slds-col": true,
    "slds-size_11-of-12": true,
    "slds-list_horizontal": true
  },
  key: 89
};
const stc43 = {
  props: {
    "iconName": "utility:new_window",
    "size": "x-small",
    "iconClass": "normal"
  },
  key: 91
};
const stc44 = {
  classMap: {
    "oppties": true,
    "slds-grid": true,
    "slds-wrap": true,
    "slds-gutters": true
  },
  key: 92
};
const stc45 = {
  classMap: {
    "slds-grid": true,
    "slds-wrap": true
  },
  key: 95
};
const stc46 = {
  classMap: {
    "slds-size_1-of-12": true,
    "slds-col": true
  },
  key: 96
};
const stc47 = {
  props: {
    "size": "x-small",
    "iconName": "utility:info",
    "iconClass": "normal"
  },
  key: 97
};
const stc48 = {
  classMap: {
    "slds-col": true,
    "slds-size_11-of-12": true,
    "slds-list_horizontal": true
  },
  key: 102
};
const stc49 = {
  props: {
    "iconName": "utility:new_window",
    "size": "x-small",
    "iconClass": "normal"
  },
  key: 104
};
const stc50 = {
  classMap: {
    "oppties": true,
    "slds-grid": true,
    "slds-wrap": true,
    "slds-gutters": true
  },
  key: 105
};
const stc51 = {
  classMap: {
    "office-hours": true,
    "slds-grid": true,
    "slds-wrap": true
  },
  key: 108
};
const stc52 = {
  classMap: {
    "slds-size_1-of-12": true,
    "slds-col": true
  },
  key: 109
};
const stc53 = {
  props: {
    "size": "x-small",
    "iconName": "utility:info",
    "iconClass": "normal"
  },
  key: 110
};
const stc54 = {
  classMap: {
    "slds-col": true,
    "slds-size_11-of-12": true,
    "slds-list_horizontal": true
  },
  key: 115
};
const stc55 = {
  props: {
    "iconName": "utility:new_window",
    "size": "x-small",
    "iconClass": "normal"
  },
  key: 117
};
const stc56 = {
  classMap: {
    "security-dev-center": true,
    "slds-grid": true,
    "slds-wrap": true
  },
  key: 120
};
const stc57 = {
  classMap: {
    "slds-size_1-of-12": true,
    "slds-col": true
  },
  key: 121
};
const stc58 = {
  props: {
    "size": "x-small",
    "iconName": "utility:info",
    "iconClass": "normal"
  },
  key: 122
};
const stc59 = {
  classMap: {
    "slds-col": true,
    "slds-size_11-of-12": true,
    "slds-list_horizontal": true
  },
  key: 127
};
const stc60 = {
  props: {
    "iconName": "utility:new_window",
    "size": "x-small",
    "iconClass": "normal"
  },
  key: 129
};
const stc61 = {
  classMap: {
    "security-dev-center": true,
    "slds-grid": true,
    "slds-wrap": true
  },
  key: 132
};
const stc62 = {
  classMap: {
    "slds-size_1-of-12": true,
    "slds-col": true
  },
  key: 133
};
const stc63 = {
  props: {
    "size": "x-small",
    "iconName": "utility:info",
    "iconClass": "normal"
  },
  key: 134
};
const stc64 = {
  classMap: {
    "slds-col": true,
    "slds-size_11-of-12": true,
    "slds-list_horizontal": true
  },
  key: 139
};
const stc65 = {
  props: {
    "iconName": "utility:new_window",
    "size": "x-small",
    "iconClass": "normal"
  },
  key: 141
};
const stc66 = {
  classMap: {
    "security-dev-center": true,
    "slds-grid": true,
    "slds-wrap": true
  },
  key: 144
};
const stc67 = {
  classMap: {
    "slds-size_1-of-12": true,
    "slds-col": true
  },
  key: 145
};
const stc68 = {
  props: {
    "size": "x-small",
    "iconName": "utility:info",
    "iconClass": "normal"
  },
  key: 146
};
const stc69 = {
  classMap: {
    "slds-col": true,
    "slds-size_11-of-12": true,
    "slds-list_horizontal": true
  },
  key: 151
};
const stc70 = {
  props: {
    "iconName": "utility:new_window",
    "size": "x-small",
    "iconClass": "normal"
  },
  key: 153
};
const stc71 = {
  key: 154
};
const stc72 = {
  classMap: {
    "slds-col": true,
    "lds-size--1-of-2": true,
    "slds-p-left_medium": true
  },
  key: 155
};
const stc73 = {
  key: 156
};
const stc74 = {
  classMap: {
    "slds-p-vertical_medium": true,
    "lds-m-top_x-large": true,
    "editor-footer-container": true
  },
  key: 157
};
const stc75 = {
  props: {
    "currentStep": "1",
    "type": "base",
    "variant": "base"
  },
  key: 158
};
const stc76 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_align-end": true,
    "submission-buttons": true
  },
  key: 161
};
const stc77 = {
  "next-button": true
};
const stc78 = {
  "data-test-id": "footer-next"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, t: api_text, b: api_bind, k: api_key, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", stc0, [api_element("div", stc1, [api_element("div", stc2, [api_custom_element("c360-icon", _c360Icon, {
    props: {
      "size": "small",
      "iconName": $cmp.iconName,
      "iconClass": $cmp.iconClass
    },
    key: 3
  }), api_static_fragment($fragment1, 5, [api_static_part(0, {
    className: api_normalize_class_name($cmp.styleClass)
  }, null), api_static_part(2, null, api_dynamic_text($cmp.submittedDateText)), api_static_part(4, null, api_dynamic_text($cmp.srDate))])]), api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text($cmp.reviewStatusTitle))]), $cmp.reviewStatusSubtitle ? api_static_fragment($fragment3, 9, [api_static_part(1, null, api_dynamic_text($cmp.reviewStatusSubtitle))]) : null]), $cmp.showChallengeRaised ? api_static_fragment($fragment4, 11, [api_static_part(2, null, api_dynamic_text($cmp.labels.challengeRaisedTitle))]) : null, $cmp.showChallengeRaised ? api_element("div", stc3, [api_element("div", stc4, [api_custom_element("c360-icon", _c360Icon, stc5)]), api_static_fragment($fragment5, 16, [api_static_part(2, null, api_dynamic_text($cmp.formattedChallengeDate))])]) : null, $cmp.showChallengeRaised ? api_static_fragment($fragment6, 18, [api_static_part(3, null, api_dynamic_text($cmp.challenge.challenge))]) : null, $cmp.showFailedSubmissionContainer ? api_custom_element("appx-security-review-submission-failed", _appxSecurityReviewSubmissionFailed, stc6) : null, $cmp.showFeedback ? api_static_fragment($fragment7, 21, [api_static_part(1, null, api_dynamic_text($cmp.labels.submissionFeedbackTitle))]) : null, $cmp.showFeedback ? api_custom_element("appx-accordion", _appxAccordion, stc7, [$cmp.feedbackCategories.invalidCredentialsMissingEnvironment ? api_custom_element("appx-accordion-row", _appxAccordionRow, stc8, [api_custom_element("c360-icon", _c360Icon, stc9), api_element("span", stc10, [api_text(api_dynamic_text($cmp.labels.missingCredentialsActions.sectionTitle))]), api_element("a", {
    slotAssignment: "summary",
    classMap: stc11,
    key: 26,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.goToStep4))
    }
  }, [api_text(api_dynamic_text($cmp.labels.missingCredentialsActions.resolveIssueLink))]), api_element("div", stc12, api_iterator($cmp.missingEnvironmentActions, function (action) {
    return [api_static_fragment($fragment8, api_key(29, action.iteratorKey), [api_static_part(1, null, api_dynamic_text(action.title))]), action.detail ? api_custom_element("i18n-link", _i18nLink, {
      classMap: stc13,
      props: {
        "message": action.detail,
        "target": "_blank"
      },
      key: api_key(30, action.iteratorKey)
    }) : null, action.additionalFeedback ? api_static_fragment($fragment9, api_key(32, action.iteratorKey), [api_static_part(3, null, api_dynamic_text($cmp.labels.additionalFeedbackSubTitle)), api_static_part(5, null, api_dynamic_text(action.additionalFeedback))]) : null];
  }))]) : null, $cmp.feedbackCategories.missingIncompleteDocumentation ? api_custom_element("appx-accordion-row", _appxAccordionRow, stc14, [api_custom_element("c360-icon", _c360Icon, stc15), api_element("span", stc16, [api_text(api_dynamic_text($cmp.labels.missingDocumentationActions.sectionTitle))]), api_element("a", {
    slotAssignment: "summary",
    classMap: stc11,
    key: 36,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.goToStep3))
    }
  }, [api_text(api_dynamic_text($cmp.labels.missingDocumentationActions.resolveIssueLink))]), api_element("div", stc17, api_iterator($cmp.missingDocs, function (action) {
    return [api_static_fragment($fragment10, api_key(39, action.iteratorKey), [api_static_part(1, null, api_dynamic_text(action.title))]), action.detail ? api_custom_element("i18n-link", _i18nLink, {
      classMap: stc13,
      props: {
        "message": action.detail,
        "target": "_blank"
      },
      key: api_key(40, action.iteratorKey)
    }) : null, action.additionalFeedback ? api_static_fragment($fragment11, api_key(42, action.iteratorKey), [api_static_part(3, null, api_dynamic_text($cmp.labels.additionalFeedbackSubTitle)), api_static_part(5, null, api_dynamic_text(action.additionalFeedback))]) : null];
  }))]) : null, $cmp.feedbackCategories.issueOrgPackage ? api_custom_element("appx-accordion-row", _appxAccordionRow, stc18, [api_custom_element("c360-icon", _c360Icon, stc19), api_element("span", stc20, [api_text(api_dynamic_text($cmp.labels.orgOrPackageIssueAction.sectionTitle))]), api_element("div", stc21, api_iterator($cmp.orgOrPackageIssues, function (action) {
    return [api_static_fragment($fragment12, api_key(48, action.iteratorKey), [api_static_part(1, null, api_dynamic_text(action.title))]), action.detail ? api_custom_element("i18n-link", _i18nLink, {
      classMap: stc13,
      props: {
        "message": action.detail,
        "target": "_blank"
      },
      key: api_key(49, action.iteratorKey)
    }) : null, action.additionalFeedback ? api_static_fragment($fragment13, api_key(51, action.iteratorKey), [api_static_part(3, null, api_dynamic_text($cmp.labels.additionalFeedbackSubTitle)), api_static_part(5, null, api_dynamic_text(action.additionalFeedback))]) : null];
  }))]) : null, $cmp.feedbackCategories.other ? api_custom_element("appx-accordion-row", _appxAccordionRow, stc22, [api_custom_element("c360-icon", _c360Icon, stc23), api_element("span", stc24, [api_text(api_dynamic_text($cmp.labels.additionalActionsTitle))]), api_element("div", stc25, [api_text(api_dynamic_text($cmp.feedbackCategories.other.otherDetail))])]) : null]) : null, $cmp.showWaitingOnPartner ? api_static_fragment($fragment14, 57, [api_static_part(1, null, api_dynamic_text($cmp.labels.submissionFeedbackTitle))]) : null, $cmp.showWaitingOnPartner ? api_custom_element("appx-accordion", _appxAccordion, stc26, [api_custom_element("appx-accordion-row", _appxAccordionRow, stc27, [api_custom_element("c360-icon", _c360Icon, stc28), api_element("span", stc29, [api_text(api_dynamic_text($cmp.labels.additionalActionsTitle))]), api_element("div", stc30, [api_text(api_dynamic_text($cmp.partnerWaitingReason))])])]) : null, $cmp.showWhatWillHappenNow ? api_static_fragment($fragment15, 64, [api_static_part(3, null, api_dynamic_text($cmp.whatWillHappenTitleByStatus)), api_static_part(5, null, api_dynamic_text($cmp.whatWillHappenNowSubtitleByStatus)), api_static_part(7, null, api_dynamic_text($cmp.subtitleSubmittedWith)), api_static_part(9, {
    attrs: {
      "alt": $cmp.labels.appyForestImage,
      "src": $cmp.images.appyForest
    }
  }, null)]) : null, api_element("div", stc31, [api_element("div", {
    className: api_normalize_class_name($cmp.opportunitiesClass),
    key: 66
  }, [$cmp.showExpiredSecurityReviewOppties ? api_element("div", stc32, [api_static_fragment($fragment16, 69, [api_static_part(1, null, api_dynamic_text($cmp.labels.opportunities))]), api_element("div", stc33, [api_element("div", stc34, [api_custom_element("c360-icon", _c360Icon, stc35)]), api_static_fragment($fragment17, 74, [api_static_part(2, null, api_dynamic_text($cmp.labels.expiredSRTroubleshoot))]), api_static_fragment($fragment18, 76), api_element("div", stc36, [api_custom_element("i18n-link", _i18nLink, {
    classMap: stc37,
    props: {
      "message": $cmp.labels.expiredSRTroubleshootLink,
      "target": "_blank"
    },
    key: 78
  }), api_custom_element("c360-icon", _c360Icon, stc38)])]), api_static_fragment($fragment19, 81), api_element("div", stc39, [api_element("div", stc40, [api_custom_element("c360-icon", _c360Icon, stc41)]), api_static_fragment($fragment20, 86, [api_static_part(2, null, api_dynamic_text($cmp.labels.expiredSRContactInfo))]), api_static_fragment($fragment21, 88), api_element("div", stc42, [api_custom_element("i18n-link", _i18nLink, {
    classMap: stc37,
    props: {
      "message": $cmp.expiredSRContactInfoLink,
      "target": "_blank"
    },
    key: 90
  }), api_custom_element("c360-icon", _c360Icon, stc43)])])]) : null, $cmp.showSecondLookOppties ? api_element("div", stc44, [api_static_fragment($fragment22, 94, [api_static_part(1, null, api_dynamic_text($cmp.labels.opportunities))]), api_element("div", stc45, [api_element("div", stc46, [api_custom_element("c360-icon", _c360Icon, stc47)]), api_static_fragment($fragment23, 99, [api_static_part(2, null, api_dynamic_text($cmp.labels.securityReviewRequirementDoc))]), api_static_fragment($fragment24, 101), api_element("div", stc48, [api_custom_element("i18n-link", _i18nLink, {
    classMap: stc37,
    props: {
      "message": $cmp.labels.securityReviewRequirementLink,
      "target": "_blank"
    },
    key: 103
  }), api_custom_element("c360-icon", _c360Icon, stc49)])])]) : null, $cmp.showOppties ? api_element("div", stc50, [api_static_fragment($fragment25, 107, [api_static_part(1, null, api_dynamic_text($cmp.labels.opportunities))]), api_element("div", stc51, [api_element("div", stc52, [api_custom_element("c360-icon", _c360Icon, stc53)]), api_static_fragment($fragment26, 112, [api_static_part(2, null, api_dynamic_text($cmp.bookOfficeHour))]), api_static_fragment($fragment27, 114), api_element("div", stc54, [api_custom_element("i18n-link", _i18nLink, {
    classMap: stc37,
    props: {
      "message": $cmp.bookOfficeHourLink,
      "target": "_blank"
    },
    key: 116
  }), api_custom_element("c360-icon", _c360Icon, stc55)])]), $cmp.statusFailed ? api_static_fragment($fragment28, 119) : null, $cmp.statusFailed ? api_element("div", stc56, [api_element("div", stc57, [api_custom_element("c360-icon", _c360Icon, stc58)]), api_static_fragment($fragment29, 124, [api_static_part(1, null, api_dynamic_text($cmp.labels.bookNonTechnicalOfficeHour))]), api_static_fragment($fragment30, 126), api_element("div", stc59, [api_custom_element("i18n-link", _i18nLink, {
    classMap: stc37,
    props: {
      "message": $cmp.labels.scheduleNonTechOfficeHour,
      "target": "_blank"
    },
    key: 128
  }), api_custom_element("c360-icon", _c360Icon, stc60)])]) : null, $cmp.statusFailed ? api_static_fragment($fragment31, 131) : null, $cmp.statusFailed ? api_element("div", stc61, [api_element("div", stc62, [api_custom_element("c360-icon", _c360Icon, stc63)]), api_static_fragment($fragment32, 136, [api_static_part(1, null, api_dynamic_text($cmp.labels.securityDevCenter))]), api_static_fragment($fragment33, 138), api_element("div", stc64, [api_custom_element("i18n-link", _i18nLink, {
    classMap: stc37,
    props: {
      "message": $cmp.labels.visitSite,
      "target": "_blank"
    },
    key: 140
  }), api_custom_element("c360-icon", _c360Icon, stc65)])]) : null, $cmp.statusFailed ? api_static_fragment($fragment34, 143) : null, $cmp.statusFailed ? api_element("div", stc66, [api_element("div", stc67, [api_custom_element("c360-icon", _c360Icon, stc68)]), api_static_fragment($fragment35, 148, [api_static_part(1, null, api_dynamic_text($cmp.labels.learnDocumentFalsePositives))]), api_static_fragment($fragment36, 150), api_element("div", stc69, [api_custom_element("i18n-link", _i18nLink, {
    classMap: stc37,
    props: {
      "message": $cmp.labels.learnDocumentFalsePositivesLink,
      "target": "_blank"
    },
    key: 152
  }), api_custom_element("c360-icon", _c360Icon, stc70)])]) : null]) : null, $cmp.showOppties ? api_custom_element("appx-security-review-raise-a-challenge", _appxSecurityReviewRaiseAChallenge, stc71) : null]), api_element("div", stc72, [$cmp.showFalsePositives ? api_custom_element("appx-security-review-false-positives", _appxSecurityReviewFalsePositives, stc73) : null])]), $cmp.showNextButton ? api_element("div", stc74, [api_custom_element("lightning-progress-indicator", _lightningProgressIndicator, stc75, [api_custom_element("lightning-progress-step", _lightningProgressStep, {
    props: {
      "label": $cmp.stepLabels.srwStepOneTitle,
      "value": "1"
    },
    key: 159
  }), api_custom_element("lightning-progress-step", _lightningProgressStep, {
    props: {
      "label": $cmp.stepLabels.srwStepSixTitle,
      "value": "2"
    },
    key: 160,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.goToReviewAndSubmit))
    }
  })])]) : null, $cmp.showNextButton ? api_element("div", stc76, [api_custom_element("c360-button", _c360Button, {
    classMap: stc77,
    attrs: stc78,
    props: {
      "label": $cmp.sharedLabels.next,
      "variant": "brand",
      "iconName": "utility:chevronright",
      "iconPosition": "right"
    },
    key: 162,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.goToReviewAndSubmit))
    }
  })]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3uuqqa6uauq";
tmpl.legacyStylesheetToken = "appx-securityReviewSubmission_securityReviewSubmission";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
